<template>
    <DSelect
        v-model="state"
        :invalid-feedback="invalidFeedback"
        :is-valid="isValid"
        :options="options"
        add-input-classes="bg-light"
        @update:value="updateValue"
    />
</template>
<script>
export default {
    name: 'DTriStateCheckbox',
    props: {
        invalidFeedback: {
            default: () => { return null },
            type: String
        },
        isValid: {
            type: [Boolean, Function],
            default: null
        },
        value: {
            type: Boolean,
            default: null
        }
    },
    emits: ['update:modelValue'],
    data () {
        return {
            state: this.value,
            options: [
                { label: this.__('messages.whatever'), value: null },
                { label: this.__('messages.yes'), value: 1 },
                { label: this.__('messages.no'), value: 0 }
            ]
        }
    },
    methods: {
        updateValue (value) {
            this.$emit('update:modelValue', value)
        }
    }
}
</script>
